import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Message } from "primereact/message";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";

import { userActions } from "../../store/user-store/user-slice";
import { uiActions } from "../../store/ui-slice";
import { getTokenInfo } from "../../utils/Guard";
import { GetCountries } from "../../store/country-store/country-actions";
import { CreateCharge, GetCharges } from "../../store/charge-store/charge-actions";
import { CreateOrganization, GetOrganizations } from "../../store/organization-store/organization-actions";
import { CreateDepartment, GetDepartments } from "../../store/department-store/department-actions";
import { Getdocumenttypes } from "../../store/documenttype-store/documenttype-actions";
import { isValidCed, isValidEmail } from "../../utils/ValidateUserInfo";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { departmentActions } from "../../store/department-store/department-slice";
import { chargeActions } from "../../store/charge-store/charge-slice";
import { organizationActions } from "../../store/organization-store/organization-slice";

let restartPage = false;

const UserForms = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user.user);
  const isValid = useSelector((state) => state.user.userValidation);
  const userInfo = getTokenInfo();
  const notification = useSelector((state) => state.ui.notification);
  const countries = useSelector((state) => state.country.countries);
  const charges = useSelector((state) => state.charge.charges);
  const department = useSelector((state) => state.department.department);
  const organizations = useSelector(
    (state) => state.organization.organizations
  );
  const organization = useSelector((state) => state.organization.organization)

  const departments = useSelector((state) => state.department.departments);
  const documenttypes = useSelector(
    (state) => state.documenttype.documenttypes
  );
  const charge = useSelector((state) => state.charge.charge);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedOrganizationCountry, setSelectedOrganizationCountry] = useState(null);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedDocumenttype, setSelectedDocumenttype] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [departmentDialog, setShowDepartmentDialog] = useState(false);
  const [organizationDialog, setShowOrganizationDialog] = useState(false);
  const [chargeDialog, setShowChargeDialog] = useState(false);

  const profiles = [
    { name: "Perteneciente", code: "PFnubeQABAPerteneciente" },
    { name: "Representante", code: "REPqscdABA" },
  ];

  useEffect(() => {
    if (organizations && organizations.length === 0) {
      dispatch(GetOrganizations(userInfo.Email, false));
    }
  }, [organizations, dispatch, userInfo.Email]);

  useEffect(() => {
    if (documenttypes && documenttypes.length === 0) {
      dispatch(Getdocumenttypes(userInfo.Email, false));
    }
  }, [documenttypes, dispatch, userInfo.Email]);

  useEffect(() => {
    if (departments && departments.length === 0) {
      dispatch(GetDepartments(userInfo.Email, false));
    }
  }, [departments, dispatch, userInfo.Email]);

  useEffect(() => {
    if (countries && countries.length === 0) {
      dispatch(GetCountries(userInfo.Email, false));
    }
  }, [countries, dispatch, userInfo.Email]);

  useEffect(() => {
    if (charges && charges.length === 0) {
      dispatch(GetCharges(userInfo.Email, false));
    }
  }, [charges, dispatch, userInfo.Email]);

  useEffect(() => {
    if (documenttypes !== undefined && documenttypes.length > 0) {
      const dt = documenttypes.filter((dt) => dt.code === "IDC")[0];


      setSelectedDocumenttype({
        id: dt.id,
        code: dt.code,
        name: dt.name,
        description: dt.description,
      });
    }
  }, [documenttypes]);

  useEffect(() => {
    if (profiles !== undefined && profiles.length > 0) {
      const code = "PFnubeQABAPerteneciente";
      onChangeProfileHandler("profile", code);
    }
  }, [profiles]);

  useEffect(() => {
    if (user && user.id !== undefined && user.id > 0) {
      if (selectedCountry === null) {
        onChangeCountriesHandler("countryid", user.country);
      }
      if (selectedOrganization === null) {
        onChangeOrganizationsHandler("organizationid", user.organization);
      }
      if (selectedCharge === null) {
        onChangeChargesHandler("chargeid", user.charge);
      }
      if (selectedDepartment === null) {
        onChangeDepartmentsHandler("departmentid", user.department);
      }
      if (selectedDocumenttype === null) {
        onChangeDocumenttypesHandler("documenttypeid", user.documentType);
      }
      if (selectedProfile === null) {
        onChangeProfileHandler("profile", user.profile)
      }
    }
  }, [user]);

  useEffect(() => {
    if (
      notification &&
      notification.status === "success" &&
      user.id > 0 &&
      restartPage
    ) {
      dispatch(userActions.restartState());
      window.location.href = "/sign/users";
    }
  }, [user.id, dispatch, navigate, notification]);

  let fitlerDepartments = departments.filter(
    (department) => department.status === "Activo"
  );
  let fitlerCharges = charges.filter((charge) => charge.status === "Activo");
  let filterorganization = organizations.filter(
    (organization) => organization.name !== ""
  );
  let fitlerDocumenttypes = documenttypes.filter(
    (documenttype) => documenttype.status === "Activo"
  );
  let fitlerCountries = countries.filter(
    (country) => country.status === "Activo"
  );

  const onSubmitDepartmentHandler = (event) => {
    event.preventDefault();
    if (department.name === "") {
      dispatch(departmentActions.setFieldValid({ id: "name", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } else {
      dispatch(CreateDepartment(department, userInfo.Email));
      restartPage = true;
    }
  };

  const onSubmitChargeHandler = (event) => {
    event.preventDefault();
    if (charge.name === "") {
      dispatch(chargeActions.setFieldValid({ id: "name", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } else {
      dispatch(CreateCharge(charge, userInfo.Email));
      restartPage = true;
    }
  };

  const onChangeHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value }));
    if (id === "identification") {
      if (isValidCed(value)) {
        dispatch(userActions.setFieldValid({ id, value: true }));
      } else {
        dispatch(userActions.setFieldValid({ id, value: false }));
      }
    } else if (id === "email") {
      if (isValidEmail(value)) {
        dispatch(userActions.setFieldValid({ id, value: true }));
      } else {
        dispatch(userActions.setFieldValid({ id, value: false }));
      }
    } else if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
  };

  const onChangeChargeHandler = (id, value) => {
    dispatch(chargeActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(chargeActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(chargeActions.setFieldValid({ id, value: false }));
    }
  };

  const onChangeOrganizationHandler = (id, value) => {
    dispatch(organizationActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(organizationActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(organizationActions.setFieldValid({ id, value: false }));
    }
  };

  const onChangeDepartmentHandler = (id, value) => {
    dispatch(departmentActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(departmentActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(departmentActions.setFieldValid({ id, value: false }));
    }
  };

  const onChangeProfileHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }

    setSelectedProfile(value);
  };

  const onChangeCountriesOrganizationHandler = (id, value) => {
    
    dispatch(organizationActions.modifyPropertyValue({ id, value: value.id }));
    if (value !== "") {
      dispatch(organizationActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(organizationActions.setFieldValid({ id, value: false }));
    }
    setSelectedOrganizationCountry({
      id: value.id,
      code: value.code,
      name: value.name,
    });
  };

  const onChangeCountriesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.id }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
    setSelectedCountry({
      id: value.id,
      code: value.code,
      name: value.name,
    });
  };

  const onChangeOrganizationsHandler = (id, value) => {

    dispatch(userActions.modifyPropertyValue({ id, value: value.id }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
    setSelectedOrganization({
      id: value.id,
      code: value.code,
      name: value.name,
    });
  };

  const selectedOrganizationTemplate = (option, props) => {
    if (
      selectedOrganization &&
      selectedOrganization.id !== undefined &&
      selectedOrganization.id > 0
    ) {
      return <div>{selectedOrganization.name}</div>;
    }

    return <span>{props.placeholder}</span>;
  };

  const onChangeChargesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.id }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
    setSelectedCharge({
      id: value.id,
      code: value.code,
      name: value.name,
    });
  };

  const selectedDepartmentTemplate = (option, props) => {
    if (
      selectedDepartment &&
      selectedDepartment.id !== undefined &&
      selectedDepartment.id > 0
    ) {
      return <div>{selectedDepartment.name}</div>;
    }

    return <span>{props.placeholder}</span>;
  };

  const onChangeDepartmentsHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.id }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
    setSelectedDepartment({
      id: value.id,
      description: value.description,
      name: value.name,
    });
  };

  const selectedChargeTemplate = (option, props) => {
    if (
      selectedCharge &&
      selectedCharge.id !== undefined &&
      selectedCharge.id > 0
    ) {
      return <div>{selectedCharge.name}</div>;
    }

    return <span>{props.placeholder}</span>;
  };

  const onChangeDocumenttypesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.id }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
    setSelectedDocumenttype({
      id: value.id,
      code: value.code,
      name: value.name,
    });
  };

  const selectedCountryTemplate = (option, props) => {
    if (
      selectedCountry &&
      selectedCountry.id !== undefined &&
      selectedCountry.id > 0
    ) {
      return (
        <div className="flex align-items-center">
          <img
            alt={selectedCountry.name}
            src={`https://flagcdn.com/48x36/${selectedCountry.code.toLowerCase()}.png`}
            style={{ width: "10%", marginRight: "1%" }}
          />

          <div>{selectedCountry.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const selectedOrganizationCountryTemplate = (option, props) => {
    if (
      selectedOrganizationCountry &&
      selectedOrganizationCountry.id !== undefined &&
      selectedOrganizationCountry.id > 0
    ) {
      return (
        <div className="flex align-items-center">
          <img
            alt={selectedOrganizationCountry.name}
            src={`https://flagcdn.com/48x36/${selectedOrganizationCountry.code.toLowerCase()}.png`}
            style={{ width: "10%", marginRight: "1%" }}
          />

          <div>{selectedOrganizationCountry.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };


  const countryOptionTemplate = (option) => {
    return (
      <div
        className="flex align-items-center"
        style={{ width: !isMobile ? "100%" : "70%" }}
      >
        <img
          alt={option.name}
          src={`https://flagcdn.com/48x36/${option.code.toLowerCase()}.png`}
          style={{ width: "18px" }}
        />
        <div style={{ marginLeft: "10%" }}>{option.name}</div>
      </div>
    );
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (user.name === "") {
      dispatch(userActions.setFieldValid({ id: "name", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } else if (selectedCountry === undefined || selectedCountry === null || selectedCountry.id === 0) {
      dispatch(userActions.setFieldValid({ id: "countryid", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "El país es obligatorio.",
        })
      );
    }
    else if (selectedDocumenttype.id === undefined || selectedDocumenttype.id === 0) {
      dispatch(userActions.setFieldValid({ id: "documenttypeid", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "El tipo de documento es obligatorio.",
        })
      );
    }
    else if (selectedCharge === undefined || selectedCharge === null || selectedCharge.id === 0) {
      dispatch(userActions.setFieldValid({ id: "chargeid", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "El cargo es obligatorio.",
        })
      );
    }
    else if (selectedDepartment == undefined || selectedDepartment == null || selectedDepartment.id === 0) {
      dispatch(userActions.setFieldValid({ id: "departmentid", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "El departamento es obligatorio.",
        })
      );
    }
    else if (selectedOrganization == undefined || selectedOrganization == null || selectedOrganization.id === 0) {
      dispatch(userActions.setFieldValid({ id: "organizationid", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "La organización es obligatoria.",
        })
      );
    }
    else if (user.identification == null || user.identification == undefined || user.identification === "") {
      dispatch(userActions.setFieldValid({ id: "identification", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "La identificación es obligatoria.",
        })
      );
    }
    else {
      const newUser = {
        ...user,
        documenttypeid: selectedDocumenttype.id,
        countryId: selectedCountry.id,
        chargeId: selectedCharge.id,
        departmentId: selectedDepartment.id,
        organizationId: selectedOrganization.id,
        profile: selectedProfile,
      }

      dispatch(props.actionUser(newUser, userInfo.Email));
      restartPage = true;
    }
  };
  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };

  const onSubmitOrganizationHandler = (event) => {
    event.preventDefault();

    if (organization.name === "") {
      dispatch(organizationActions.setFieldValid({ id: "name", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.identifier === "") {
      dispatch(organizationActions.setFieldValid({ id: "identifier", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.countryId === "") {
      dispatch(organizationActions.setFieldValid({ id: "countryId", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.city === "") {
      dispatch(organizationActions.setFieldValid({ id: "city", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.zipCode === "") {
      dispatch(organizationActions.setFieldValid({ id: "zipCode", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.address === "") {
      dispatch(organizationActions.setFieldValid({ id: "address", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.email === "") {
      dispatch(organizationActions.setFieldValid({ id: "email", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.ra === "") {
      dispatch(organizationActions.setFieldValid({ id: "ra", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else {
      dispatch(CreateOrganization(organization, userInfo.Email));
      restartPage = true;
    }
  };

  return (
    <>
      <Card
        style={{
          backgroundColor: "#F9FAFB",
          marginBottom: "0",
          boxShadow: "none",
          height: "auto",
          width: "100%",
        }}
      >
        <form onSubmit={onSubmitHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <h2 className="card-header" style={{ color: "" }}>
                Nombre :
                <span style={{ color: "#D34330", marginLeft: "1%" }}>
                  {user &&
                    user.name + " " + user.surname1 + " " + user.surname2}
                </span>
              </h2>
            </div>
            <div className="field col-12 md:col-4">
              <label
                htmlFor="name"
                style={{ fontSize: "large", color: "", marginRight: "5%" }}
              >
                Nombre:
              </label>
              <br />
              <InputText
                id="name"
                value={user.name}
                onChange={(e) => onChangeHandler("name", e.target.value)}
                placeholder=""
                style={{ width: !isMobile ? "100%" : "70%" }}
              />
              <div>{getFormErrorMessage("name")}</div>
            </div>
            <div className="field col-12 md:col-4">
              <label
                htmlFor="surname1"
                style={{ fontSize: "large", color: "", marginRight: "5%" }}
              >
                Primer apellido:
              </label>
              <br />
              <InputText
                id="surname1"
                value={user.surname1}
                onChange={(e) => onChangeHandler("surname1", e.target.value)}
                placeholder=""
                style={{ width: !isMobile ? "100%" : "70%" }}
              />
              <div>{getFormErrorMessage("surname1")}</div>
            </div>

            <div className="field col-12 md:col-4">
              <label
                htmlFor="surname2"
                style={{ fontSize: "large", color: "", marginRight: "5%" }}
              >
                Segundo Apellido:
              </label>
              <br />
              <InputText
                id="surname2"
                value={user.surname2}
                onChange={(e) => onChangeHandler("surname2", e.target.value)}
                placeholder=""
                style={{ width: !isMobile ? "100%" : "70%" }}
              />
              <div>{getFormErrorMessage("surname2")}</div>
            </div>

            {/* <div className="field col-12 md:col-4">
              <label
                htmlFor="documenttypeid"
                style={{ fontSize: "large", color: "" }}
              >
                Tipo de Documento:
              </label>
              <br />
              <Dropdown
                value={selectedDocumenttype}
                onChange={(e) => {
                  onChangeDocumenttypesHandler("documenttypeid", e.value);
                }}
                options={fitlerDocumenttypes}
                optionLabel="name"
                placeholder="Seleccionar un tipo de documento"
                valueTemplate={selectedDocumenttypeTemplate}
                filter
                style={{
                  width: !isMobile ? "100%" : "70%",
                  height: "50%",
                }}
              />
              <div>{getFormErrorMessage("documenttypeid")}</div>
            </div> */}

            <div className="field col-12 md:col-4">
              <label
                htmlFor="identification"
                style={{ fontSize: "large", color: "" }}
              >
                Identificacion:
              </label>
              <br />
              <InputMask
                id="identification"
                value={user.identification}
                onChange={(e) =>
                  onChangeHandler("identification", e.target.value)
                }
                mask="999-9999999-9"
                placeholder="999-9999999-9"
                style={{ width: !isMobile ? "100%" : "70%" }}
              />
              <div>{getFormErrorMessage("identification")}</div>
            </div>

            <div className="field col-12 md:col-4">
              <label
                htmlFor="email"
                style={{ fontSize: "large", color: "", marginRight: "5%" }}
              >
                Email:
              </label>
              <br />
              <InputText
                id="email"
                value={user.email}
                onChange={(e) => onChangeHandler("email", e.target.value)}
                placeholder=""
                style={{
                  width: !isMobile ? "100%" : "70%",
                  marginRight: "5%",
                }}
              />
              <div>{getFormErrorMessage("email")}</div>
            </div>
            <div className="field col-12 md:col-4">
              <label
                htmlFor="departmentid"
                style={{ fontSize: "large", color: "" }}
              >
                Departamento:
              </label>


              <br />
              <div className="flex col-11">
                <Dropdown
                  value={selectedDepartment}
                  onChange={(e) => {
                    onChangeDepartmentsHandler("departmentid", e.value);
                  }}
                  options={fitlerDepartments}
                  optionLabel="name"
                  placeholder="Seleccionar departamento"
                  valueTemplate={selectedDepartmentTemplate}
                  filter
                  style={{
                    width: !isMobile ? "100%" : "70%",
                  }}
                />
                <Button type="button" icon="pi pi-plus" rounded className="addButton col-2" onClick={() => setShowDepartmentDialog(true)} />
              </div>
              <div>{getFormErrorMessage("departmentid")}</div>
            </div>

            <div className="field col-12 md:col-4">
              <label
                htmlFor="organizationid"
                style={{ fontSize: "large", color: "" }}
              >
                Organización:
              </label>
              <br />
              <div className="flex col-11">
                <Dropdown
                  value={selectedOrganization}
                  onChange={(e) => {
                    onChangeOrganizationsHandler("organizationid", e.value);
                  }}
                  filter
                  options={filterorganization}
                  placeholder="Seleccionar cargo"
                  valueTemplate={selectedOrganizationTemplate}
                  optionLabel="name"
                  style={{
                    width: !isMobile ? "100%" : "70%",
                    height: "50%",
                  }}
                />
                <Button type="button" icon="pi pi-plus" rounded className="addButton col-1" onClick={() => setShowOrganizationDialog(true)} />
                <div>{getFormErrorMessage("organizationid")}</div>
              </div>
            </div>

            <div className="field col-12 md:col-4">
              <label
                htmlFor="charge"
                style={{ fontSize: "large", color: "", marginRight: "5%" }}
              >
                Cargo:
              </label>
              <br />
              <div className="flex col-11">

                <Dropdown
                  value={selectedCharge}
                  onChange={(e) => {
                    onChangeChargesHandler("chargeid", e.value);
                  }}
                  options={fitlerCharges}
                  placeholder="Seleccionar cargo"
                  filter
                  valueTemplate={selectedChargeTemplate}
                  optionLabel="name"
                  style={{
                    width: !isMobile ? "100%" : "70%",
                    height: "50%",
                  }}
                />
                <Button type="button" icon="pi pi-plus" rounded className="addButton col-2" onClick={() => setShowChargeDialog(true)} />

              </div>
              <div>{getFormErrorMessage("chargeid")}</div>
            </div>

            <div className="field col-12 md:col-4">
              <label
                htmlFor="countryid"
                style={{ fontSize: "large", color: "", marginRight: "20%" }}
              >
                País:
              </label>
              <br />
              <Dropdown
                value={selectedCountry}
                onChange={(e) => {
                  onChangeCountriesHandler("countryid", e.value);
                }}
                options={fitlerCountries}
                optionLabel="name"
                placeholder="Seleccionar pais"
                valueTemplate={selectedCountryTemplate}
                filter
                itemTemplate={countryOptionTemplate}
                style={{
                  width: !isMobile ? "100%" : "70%",
                  height: "50%",
                }}
              />
              <div>{getFormErrorMessage("countryid")}</div>
            </div>

            <div className="field col-12 md:col-4">
              <label
                htmlFor="cellPhone"
                style={{ fontSize: "large", color: "" }}
              >
                Teléfono:
              </label>
              <br />
              <InputMask
                id="cellPhone"
                value={user.cellPhone}
                onChange={(e) => onChangeHandler("cellPhone", e.target.value)}
                mask="+1999-999-9999"
                placeholder="+1999-999-9999"
                style={{
                  width: !isMobile ? "100%" : "70%",
                  marginRight: "3%",
                }}
              />
              <div>{getFormErrorMessage("cellPhone")}</div>
            </div>

            <div className="field col-12 md:col-4">
              <label htmlFor="city" style={{ fontSize: "large", color: "" }}>
                Ciudad:
              </label>
              <br />
              <InputText
                id="city"
                value={user.city}
                onChange={(e) => onChangeHandler("city", e.target.value)}
                placeholder=""
                style={{
                  width: !isMobile ? "100%" : "70%",
                  marginRight: "5%",
                }}
              />
              <div>{getFormErrorMessage("city")}</div>
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="address" style={{ fontSize: "large", color: "" }}>
                Dirección:
              </label>
              <br />
              <InputText
                id="address"
                value={user.address}
                onChange={(e) => onChangeHandler("address", e.target.value)}
                placeholder=""
                style={{
                  width: !isMobile ? "100%" : "70%",
                  marginRight: "3%",
                }}
              />
              <div>{getFormErrorMessage("address")}</div>
            </div>
          </div>

          <div className="formgrid grid">
            {!props.isModal && (
              <Button
                rounded
                text
                raised
                style={{ backgroundColor: "#fff" }}
                label="Regresar"
                icon="pi pi-arrow-left"
                className="p-button-danger"
                onClick={() => {
                  navigate("/sign/users");
                }}
              />
            )}
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%" }}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>


      </Card>

      <Dialog
        header="Crear Nuevo Cargo"
        visible={chargeDialog}
        style={{ width: '50vw' }}
        onHide={() => setShowChargeDialog(false)}
        breakpoints={{ '960px': '75vw', '641px': '90vw' }}
      >

        <form onSubmit={onSubmitChargeHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <h2 className="card-header" style={{ color: "" }}>
                Cargo:
                <span style={{ color: "#D34330", marginLeft: "1%" }}>
                  {charge && charge.name && charge.name}
                </span>
              </h2>
            </div>
            <div className="field col-12 md:col-6">
              <label
                htmlFor="name"
                style={{ fontSize: "large", color: "" }}
              >
                Nombre:
              </label>
              <InputText
                id="name"
                value={charge.name}
                onChange={(e) => onChangeChargeHandler("name", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("name")}</div>
            </div>
            <div className="field col-12 md:col-8">
              <label
                htmlFor="description"
                style={{ fontSize: "large", color: "" }}
              >
                Descripción:
              </label>
              <InputTextarea
                id="description"
                rows={4}
                cols={10}
                value={charge.description}
                onChange={(e) => onChangeChargeHandler("description", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div className="formgrid grid">
            <Button
              rounded
              text
              raised
              style={{ marginLeft: "0.6%", backgroundColor: "#fff" }}
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-danger"
              onClick={() => {
                setShowChargeDialog(false);
              }}
            />
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%" }}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>

      </Dialog>

      <Dialog
        header="Crear Nuevo Departamento"
        visible={departmentDialog}
        style={{ width: '50vw' }}
        onHide={() => setShowDepartmentDialog(false)}
        breakpoints={{ '960px': '75vw', '641px': '90vw' }}
      >

        <form onSubmit={onSubmitDepartmentHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <h2 className="card-header" style={{ color: "" }}>
                Departamento:
                <span style={{ color: "", marginLeft: "1%" }}>
                  {department && department.name && department.name}
                </span>
              </h2>
            </div>
            <div className="field col-12 md:col-6">
              <label
                htmlFor="name"
                style={{ fontSize: "large", color: "" }}
              >
                Nombre:
              </label>
              <InputText
                id="name"
                value={department.name}
                onChange={(e) => onChangeDepartmentHandler("name", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("name")}</div>
            </div>
            <div className="field col-12 md:col-8">
              <label
                htmlFor="description"
                style={{ fontSize: "large", color: "" }}
              >
                Descripción:
              </label>
              <InputTextarea
                id="description"
                rows={4}
                cols={10}
                value={department.description}
                onChange={(e) => onChangeDepartmentHandler("description", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div className="formgrid grid">
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff" }}
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-danger"
              onClick={() => {
                setShowDepartmentDialog(false);
              }}
            />
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%" }}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>

      </Dialog>

      <Dialog
        header="Crear Nueva Organización"
        visible={organizationDialog}
        style={{ width: '60vw' }}
        onHide={() => setShowOrganizationDialog(false)}
        breakpoints={{ '960px': '75vw', '641px': '95vw' }}
      >

        <form onSubmit={onSubmitOrganizationHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <h2 className="card-header" style={{ color: "" }}>
                Nombre:
                <span style={{ color: "#D34330", marginLeft: "1%" }}>
                  {organization && organization.name && organization.name}
                </span>
              </h2>
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="name" style={{ fontSize: "large", color: "" }}>
                Nombre:
              </label>
              <InputText
                id="name"
                value={organization.name}
                onChange={(e) => onChangeOrganizationHandler("name", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
            </div>
            <div className="field col-12 md:col-4">
              <label
                htmlFor="identifier"
                style={{ fontSize: "large", color: "" }}
              >
                Identificador:
              </label>
              <InputText
                id="identifier"
                value={organization.identifier}
                onChange={(e) => onChangeOrganizationHandler("identifier", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
            </div>
            <div className="field col-12 md:col-4">
              <label
                htmlFor=" countryId"
                style={{ fontSize: "large", color: "", marginRight: "20%" }}
              >
                País:
              </label>
              <br />
              <Dropdown
                value={selectedOrganizationCountry}
                onChange={(e) => {
                  onChangeCountriesOrganizationHandler("countryId", e.value);
                }}
                options={fitlerCountries}
                optionLabel="name"
                placeholder="Seleccionar pais"
                valueTemplate={selectedOrganizationCountryTemplate}
                filter
                itemTemplate={countryOptionTemplate}
                style={{
                  width: "100%",
                  height: "50%",
                }}
              />
            </div>
            <div className="field col-12 md:col-3">
              <label htmlFor="city" style={{ fontSize: "large", color: "" }}>
                Ciudad:
              </label>
              <InputText
                id="city"
                value={organization.city}
                onChange={(e) => onChangeOrganizationHandler("city", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
            </div>
            <div className="field col-12 md:col-3">
              <label htmlFor="zipCode" style={{ fontSize: "large", color: "" }}>
                Código Postal:
              </label>
              <InputText
                id="zipCode"
                value={organization.zipCode}
                onChange={(e) => onChangeOrganizationHandler("zipCode", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
            </div>
            <div className="field col-12 md:col-3">
              <label htmlFor="address" style={{ fontSize: "large", color: "" }}>
                Dirección:
              </label>
              <InputText
                id="address"
                value={organization.address}
                onChange={(e) => onChangeOrganizationHandler("address", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
            </div>
            <div className="field col-12 md:col-3">
              <label htmlFor="Email" style={{ fontSize: "large", color: "" }}>
                Email:
              </label>
              <InputText
                id="Email"
                value={organization.email}
                onChange={(e) => onChangeOrganizationHandler("email", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
            </div>
            {/* <div className="field col-12 md:col-3">
              <label htmlFor="ra" style={{ fontSize: "large", color: "" }}>
                RA:
              </label>
              <InputText
                id="ra"
                value={organization.ra}
                onChange={(e) => onChangeHandler("ra", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("ra")}</div>
            </div> */}
          </div>
          <div className="formgrid grid">
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff" }}
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-danger"
              onClick={() => {
                setShowOrganizationDialog(false);
              }}
            />
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%" }}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>

      </Dialog>
    </>
  );
};
export default UserForms;
